import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  KTextInput,
  KSelect,
  KSelectAutocomplete,
} from "@kyburz/kdesign-system";
import useSetState from "../../../hooks/useSetState";
import BaseLayout from "../../../components/layouts/BaseLayout";
import JsonTextInput from "../../../components/JsonTextInput";
import KFormBackground from "../../../components/ui/KFormBackground";
import { createDevice } from "../../../apiCalls/config/devices";
import { setAlert } from "../../../redux/actions/actions";
import { getCustomers } from "../../../apiCalls/auth";
import { getFullTemplates } from "../../../apiCalls/config/fullTemplates";
import { hardwareTypes } from "../../../utils/hardwareTypes";

const NewDevice: React.FC = () => {
  const history: any = useHistory();
  const dispatch = useDispatch();

  const [
    {
      imei,
      customer,
      template,
      hardware,
      sim_type,
      template_overwrite,
      transformation_overwrite,
      variables,
      errors,
      formControlCustomers,
      formControlTemplates,
    },
    setState,
  ] = useSetState({
    imei: "",
    customer: "",
    template: "",
    hardware: "",
    sim_type: "",
    template_overwrite: {},
    transformation_overwrite: {},
    variables: {},
    errors: {
      imei: null,
    },
    formControlCustomers: [],
    formControlTemplates: [],
  });

  useEffect(() => {
    getCustomers().then((res) => {
      setState({
        formControlCustomers: res.data
          .filter((el) => el._id !== null)
          .map((el) => ({ label: el.shortname })),
      });
    });
    getFullTemplates("", 1, null)
      .then((res) => {
        setState({
          formControlTemplates: res.data.map((el) => ({ label: el.name })),
        });
      })
      .catch((e) => console.error(e));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await createDevice(
      customer,
      imei,
      template,
      hardware,
      sim_type,
      template_overwrite,
      transformation_overwrite,
      variables,
    );
    if (res.errors) {
      setState({ errors: res.errors });
    } else {
      history.push("/config/devices/devices");
      dispatch(setAlert("Device created", "success"));
    }
  };

  const handleChange = (e) =>
    setState({ [e.target.name]: e.target.value, errors: { imei: null } });
  const handleJsonChangeTemplateOverride = (code) =>
    setState({ template_overwrite: code });
  const handleJsonChangeTransformationOverwrite = (code) =>
    setState({ transformation_overwrite: code });
  const handleJsonChangeVariables = (code) => setState({ variables: code });
  const handleSelect = (value, name) => setState({ [name]: value.label });
  const handleSelectAutoComplete = (name, value) => {
    setState({ [name]: value.label });
  };

  return (
    <BaseLayout
      title="Create New Device"
      handleArrowClick={() => history.goBack()}
    >
      <KFormBackground
        size="large"
        primaryCTAColor="primary"
        primaryCTAonClick={handleSubmit}
        primaryCTAText="Save"
        secondaryCTAText="Cancel"
        secondaryCTAonClick={() => history.goBack()}
      >
        <div style={{ display: "flex" }}>
          <KTextInput
            label="IMEI"
            name="imei"
            value={imei}
            onChange={handleChange}
            width="240px"
            placeholder="490154203237518"
            helperText="A valid IMEI 15-16 digits."
            required={true}
            style={{ marginRight: "24px" }}
            error={errors.imei != null}
            errorText={errors.imei}
          />
          <KSelectAutocomplete
            label="Customer"
            name="customer"
            value={customer}
            onChange={handleSelectAutoComplete}
            elements={formControlCustomers}
            style={{ marginRight: 24, width: 240 }}
          />
        </div>
        <div style={{ display: "flex" }}>
          <KSelect
            label="Template"
            value={template}
            name="template"
            onSelect={handleSelect}
            elements={formControlTemplates}
            style={{ marginRight: "24px", width: 240 }}
          />
          <KSelect
            onSelect={handleSelect}
            elements={hardwareTypes}
            style={{ marginRight: "24px", width: 240 }}
            label="Hardware Type"
            name="hardware"
            value={hardware}
          />
          <KSelect
            label="SIM Type"
            name="sim_type"
            value={sim_type}
            onSelect={handleSelect}
            elements={[
              { label: "None" },
              { label: "Local" },
              { label: "Global" },
            ]}
            style={{ width: "240px" }}
          />
        </div>
        <div>
          <JsonTextInput
            label="Template overwrite"
            value={template_overwrite}
            handleSubmit={handleJsonChangeTemplateOverride}
            style={{ display: "inline-block", marginRight: "24px" }}
          />
          <JsonTextInput
            label="Transformation overwrite"
            value={transformation_overwrite}
            handleSubmit={handleJsonChangeTransformationOverwrite}
            style={{ display: "inline-block" }}
          />
          <JsonTextInput
            label="Variables"
            value={variables}
            handleSubmit={handleJsonChangeVariables}
          />
        </div>
      </KFormBackground>
    </BaseLayout>
  );
};

export default NewDevice;
